// src/pages/Reports/OrdersReport.jsx
import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import Toast from '../../components/Toast/Toast';
import './OrdersReport.css';

const OrdersReport = () => {
  const { user, isSuperAdmin } = useAuth();

  const [stats, setStats] = useState({
    totalOrders: 0,
    pendingOrders: 0,
  });
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    fetchStats();
    fetchOrders();
  }, []);

  const fetchStats = async () => {
    try {
      const companyId = isSuperAdmin 
        ? localStorage.getItem('selectedCompanyId')
        : user?.companyId;

      const token = localStorage.getItem('token');
      const params = companyId ? { companyId } : {};

      const response = await api.get('/orders-report/stats', { params });

      if (response.data.success) {
        setStats(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const companyId = isSuperAdmin 
        ? localStorage.getItem('selectedCompanyId')
        : user?.companyId;

      const token = localStorage.getItem('token');
      const params = companyId ? { companyId } : {};
      const response = await api.get('/orders-report/this-month', { params });

      if (response.data.success) {
        setOrders(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching orders:', error);
      setToast({ message: 'Failed to fetch orders', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  return (
    <div className="orders-report-page">
      {/* Toast Notification */}
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}

      {/* Page Header */}
      <div className="page-header">
        <div className="breadcrumb">
          <span className="breadcrumb-item">Home</span>
          <span className="breadcrumb-separator">/</span>
          <span className="breadcrumb-item active">Dashboard</span>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="stats-cards-grid">
        {/* Total Orders Card */}
        <div className="stat-card">
          <div className="stat-card-header">
            <h3 className="stat-card-title">Orders</h3>
            <span className="stat-card-period">| This Month</span>
            <button className="stat-menu">⋯</button>
          </div>
          <div className="stat-card-content">
            <div className="stat-icon-wrapper blue">
              <div className="stat-icon">🚗</div>
            </div>
            <div className="stat-value">{stats.totalOrders}</div>
          </div>
        </div>

        {/* Pending Orders Card */}
        <div className="stat-card">
          <div className="stat-card-header">
            <h3 className="stat-card-title">Pending</h3>
            <span className="stat-card-period">| This Month</span>
            <button className="stat-menu">⋯</button>
          </div>
          <div className="stat-card-content">
            <div className="stat-icon-wrapper green">
              <div className="stat-icon">⏰</div>
            </div>
            <div className="stat-value">{stats.pendingOrders}</div>
          </div>
        </div>
      </div>

      {/* All Orders Table */}
      <div className="orders-table-section">
        <div className="section-header">
          <h3 className="section-title">All Orders</h3>
          <span className="section-period">| This Month</span>
        </div>

        <div className="table-container">
          {loading ? (
            <div className="loading">Loading orders...</div>
          ) : (
            <table className="orders-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>ShopName</th>
                  <th>Godown</th>
                </tr>
              </thead>
              <tbody>
                {orders.length > 0 ? (
                  orders.map((order, index) => (
                    <tr key={index}>
                      <td>{formatDate(order.orderDate)}</td>
                      <td>{order.shopName}</td>
                      <td>{order.godown}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="no-data">
                      No orders this month
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrdersReport;